import React, { useState } from 'react';
import { useAuthentication } from '@montana/containers/authentication';
import { Form, FormTextInput, Checkbox } from '../form';
import { IFormValues } from '../form/form.component';
import { required } from '../form/validation';
import { Button } from '../button';
import { Expand } from '@montana/shared/expand';
import { useDynamicSettings } from '@montana/containers/dynamic-settings';

export interface ILoginModule {
    className?: string;
    loginButtonText?: string;
    loginErrorMessage?: string;
    passwordPlaceholder?: string;
    usernamePlaceholder?: string;
    rememberMeText?: string;
    autoFocus?: boolean;
}

export const LoginModule: React.FC<ILoginModule> = React.memo(({
    className,
    loginButtonText,
    loginErrorMessage,
    passwordPlaceholder,
    usernamePlaceholder,
    rememberMeText,
    autoFocus,
}: ILoginModule): JSX.Element => {
    const { rememberMe } = useDynamicSettings();
    const { authenticationIsLoading, login, showAuthenticationError } = useAuthentication();

    const [remember, setRemember] = useState(!!rememberMe);

    const handleSubmit = (values: IFormValues): void => {
        login(values.username, values.password, remember);
    };

    return (
        <div className={`login-module ${className}`}>
            <Form onSubmit={handleSubmit} initialValues={{}}>
                <FormTextInput
                    type="text"
                    name="username"
                    floatingLabel
                    label={usernamePlaceholder}
                    autoFocus={autoFocus}
                    validate={required("Field required")}
                    required
                />

                <FormTextInput
                    type="password"
                    name="password"
                    floatingLabel
                    label={passwordPlaceholder}
                    validate={required("Field required")}
                    required
                />

                <Button submitButton isLoading={authenticationIsLoading} className="login-module__submit-button">
                    {loginButtonText}
                </Button>

                <Checkbox isChecked={remember} onCheck={setRemember} className="login-module__remember-me">
                    {rememberMeText}
                </Checkbox>

                <Expand active={!!showAuthenticationError}>
                    <div className="login-module__error field-wrapper__error">
                        <span className="field-wrapper__error-text">
                            {loginErrorMessage}
                        </span>
                    </div>
                </Expand>
            </Form>
        </div>
    );

});
